
// ==========================================
// 9. src/components/sections/SuccessSection.js
// ==========================================
import React from 'react';
import { Package, Clock, Shield, TrendingUp } from 'lucide-react';

const SuccessCard = ({ icon: Icon, title, description }) => (
  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
    <Icon className="w-10 h-10 text-blue-200 mb-4" />
    <h3 className="text-lg font-semibold mb-2">{title}</h3>
    <p className="text-blue-100">{description}</p>
  </div>
);

const MetricCard = ({ value, label }) => (
  <div className="text-center">
    <p className="text-3xl font-bold">{value}</p>
    <p className="text-sm text-blue-200">{label}</p>
  </div>
);

const SuccessSection = () => {
  const successes = [
    {
      icon: Package,
      title: 'Automated Tender→POD',
      description: 'Loads flow through your system without manual touches'
    },
    {
      icon: Clock,
      title: 'Live Tracking',
      description: 'Real-time visibility for your team and customers'
    },
    {
      icon: Shield,
      title: 'Strong Compliance',
      description: 'USPS and commercial requirements handled automatically'
    },
    {
      icon: TrendingUp,
      title: 'Faster Cash Cycle',
      description: 'Automated reconciliation turns hours of manual work into seconds.'
    }
  ];

  const metrics = [
    { value: '100%', label: 'Technology Compliance' },
    { value: '100x', label: 'Fewer manual touches' },
    { value: 'Instant', label: 'Payment discrepancy visibility' },
    { value: '24/7', label: 'Operational coverage' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 to-indigo-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Your New Reality with SYBR TMS</h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            This is what winning looks like in modern logistics
          </p>
        </div>

        {/* Success Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {successes.map((success, index) => (
            <SuccessCard key={index} {...success} />
          ))}
        </div>

        {/* Metrics Banner */}
        <div className="mt-12 bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <div className="text-center">
            <p className="text-2xl font-semibold mb-4">
              Join logistics leaders who've transformed their operations
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {metrics.map((metric, index) => (
                <MetricCard key={index} {...metric} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessSection;